import { get, post, httpDelete } from '../../utils/api';
import { Order } from '../../state/models/Order';

const endpoint = `/api/orders`;

export async function loadById(orderId: number): Promise<Order> {
    return get<Order>(`${endpoint}/${orderId}`);
}